import {utils} from '@wallaby-ui/core';

// import * as Components from 'src/js/common/components/static';
import {LIBRARY_NAME} from 'src/js/common/constants';

const logger = utils.LogUtils.getLogger(
  'StaticComponentsDefinitions',
  LIBRARY_NAME
);

// const ATB_RESISTANCE_LEGEND = 'AtbResistanceLegend';
const UNKNOWN_COMPONENT = 'unknown';

export const StaticComponentsDefinitions = {
  /*
  [ATB_RESISTANCE_LEGEND]: {
    component: Components.AtbResistanceLegend,
  },
  */
};

export class StaticComponent {
  static getComponent(componentName) {
    let result;
    if (StaticComponentsDefinitions[componentName]) {
      result = StaticComponentsDefinitions[componentName].component;
    } else {
      logger.warn(
        `Unrecognized component for StaticComponent: ${componentName}`
      );
      result = StaticComponentsDefinitions[UNKNOWN_COMPONENT].component;
    }
    return result;
  }

  static getComponentDefinition(componentName) {
    return StaticComponentsDefinitions[componentName];
  }
}

export default {StaticComponent};
